import { ISVGSettings, SVGSettingsNestedKey } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import { Dispatch, memo, SetStateAction, useCallback, useEffect, useState } from 'react'
import formsUtils from '@/shared/Forms/forms.utils.ts'
import svgChartGenerators from '@/pages/Dashboards/Charts/SVGChart/svgChart.generators.ts'
import SvgChartSettingsContentCommonInfoStep from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/SVGChartSettingsContent/SvgChartSettingsContentCommonInfoStep'
import SvgChartSettingsSecondStep from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/SVGChartSettingsContent/SvgChartSettingsSecondStep'

interface IProps {
  step: 'common-info' | 'settings'
  setSettings: Dispatch<SetStateAction<ISVGSettings>>
  settings?: ISVGSettings
}

const SVGChartSettingsContent = (props: IProps) => {
  const [settings, setSettings] = useState(props.settings || svgChartGenerators.generateEmptySvgSettings())

  useEffect(() => {
    props.setSettings(settings)
  }, [settings, props.setSettings])

  // Создать новый line настроек
  const handleCreateNewNestedElement = useCallback(
    (key: SVGSettingsNestedKey) => {
      setSettings((prev) => ({
        ...prev,
        [key]: [...prev[key], svgChartGenerators.generateNewSettingsLine(key)],
      }))
    },
    [setSettings]
  )

  // Обновить line настроек
  const handleNestedElementUpdate = useCallback(
    (index: number, value: any, key: string, nestedKey: SVGSettingsNestedKey) => {
      setSettings((prev) => ({
        ...prev,
        [nestedKey]: formsUtils.arrays.updateItem(prev[nestedKey], { [key]: value } as any, index),
      }))
    },
    [setSettings]
  )

  // Удалить line настроек
  const handleNestedElementDelete = useCallback(
    (index: number, nestedKey: SVGSettingsNestedKey) => {
      setSettings((prev) => ({
        ...prev,
        [nestedKey]: formsUtils.arrays.removeItem(prev[nestedKey], index),
      }))
    },
    [setSettings]
  )

  const handleChange = useCallback(
    (val: any, name: string) => {
      setSettings((prev) => ({ ...prev, [name]: val }))
    },
    [setSettings]
  )

  if (props.step === 'common-info') {
    return <SvgChartSettingsContentCommonInfoStep settings={settings} onChange={handleChange} />
  }

  return (
    <SvgChartSettingsSecondStep
      settings={settings}
      handleCreateNewNestedElement={handleCreateNewNestedElement}
      handleNestedElementUpdate={handleNestedElementUpdate}
      handleNestedElementDelete={handleNestedElementDelete}
    />
  )
}

export default memo(SVGChartSettingsContent)
